import { Divider, Menu, MenuItem } from "@mui/material";
import Button from "components/common/Button";
import NoDataBanner from "components/common/NoDataBanner";
import Typography from "components/common/Typography";
import SearchAppBar from "components/common/searchBar";
import { useTranslate } from "hooks/useTranslate";
import { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { tokens } from "styles/Tokens";
import { minSearchStrLength } from "utils/CommonConstants";
import { setIsCreateInnCodeModal, setUploadOrCreate } from "../CorpUser.Slice";
import AccordionData from "./AccordionData";
import { getListData, searchInMyLists } from "./MyLists";
import "./MyLists.scss";

export default function LeftWrapper({ open, setOpen }: any) {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const translate = useTranslate();

  const savedFiltersAndLists = useAppSelector((state) => state.filters.savedFilter);
  const isSmeUser = useAppSelector((state) => state.app.isSmeUser);

  const [listData, setListData] = useState<any>();
  const [searchedText, setSearchedText] = useState<string>("");
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const opens = Boolean(anchorEl);

  useEffect(() => {
    getInputDetail();
  }, [searchedText, savedFiltersAndLists]);

  const getInputDetail = useCallback(() => {
    if (searchedText.length > minSearchStrLength || !searchedText) {
      const list = getListData(isSmeUser, dispatch, savedFiltersAndLists);
      const searchedList = searchedText?.length ? searchInMyLists(searchedText, list) : list;
      setListData(searchedList);
    }
  }, [searchedText, savedFiltersAndLists]);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = (value: string) => {
    setAnchorEl(null);
    dispatch(setUploadOrCreate(value));
    dispatch(setIsCreateInnCodeModal(true));
  };

  return (
    <div className="my-list-corp-left-wrapper">
      <SearchAppBar
        sx={{ height: "44px", border: `solid 1px ${tokens.Border.General.Tertiary}` }}
        getInputDetails={(val: string) => setSearchedText(val)}
      />
      {listData?.length ? (
        <div className="my-list-corp-accordian">
          {listData?.map((item: any) => {
            if (!isSmeUser && item.listType === "consultant") return <></>;
            return (
              <div key={item?.id}>
                {" "}
                <AccordionData
                  item={item}
                  setOpen={(val: boolean) => setOpen(val)}
                  searchedText={searchedText}
                  keyId={`accordion-${item?.id}`}
                />
              </div>
            );
          })}
        </div>
      ) : (
        <NoDataBanner noDataMessage={translate("common.noResults")} />
      )}

      <div
        id="demo-positioned-button"
        aria-controls={open ? "create-list-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        onClick={handleClick}
      >
        <Divider></Divider>
        <Button variant="outlined" label={"Create New List"} className="my-list-corp-create-button" />
      </div>
      <Menu
        id="create-list-menu"
        aria-labelledby="demo-positioned-button"
        anchorEl={anchorEl}
        open={opens}
        onClose={() => setAnchorEl(null)}
        anchorOrigin={{
          vertical: "top",
          horizontal: "right"
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left"
        }}
      >
        <MenuItem onClick={() => handleClose("create")}>
          <div>
            <Typography variant="body2" showBold color={tokens.Text.General.PrimaryHeadline}>
              {translate("list.create.inncode")}
            </Typography>
            <Typography variant="label" color={tokens.Text.General.Secondary}>
              {translate("list.createScratch")}
            </Typography>
          </div>
        </MenuItem>
        <MenuItem onClick={() => handleClose("upload")} className="mt20">
          <div>
            <Typography variant="body2" showBold color={tokens.Text.General.PrimaryHeadline}>
              {translate("list.uploadInncode")}
            </Typography>
            <Typography variant="label" color={tokens.Text.General.Secondary}>
              {translate("list.uploadInncode.placeHolder")}
            </Typography>
          </div>
        </MenuItem>
        <MenuItem className="mt20">
          <div className="dashboard-redirect">
            <Typography variant="label" color={tokens.Text.General.Secondary}>
              {translate("list.uploadInncode.uploadInfo")}
            </Typography>
            <Typography
              variant="label"
              color={tokens.Text.General.Color}
              className="dashboard-text"
              onClick={() => navigate("/CorporateDashboard")}
            >
              Dashboard
            </Typography>
          </div>
        </MenuItem>
      </Menu>
    </div>
  );
}
